import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-add-joining-query',
  templateUrl: './add-joining-query.component.html',
  styleUrls: ['./add-joining-query.component.scss']
})
export class AddJoiningQueryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
